import { useAuth } from "@dl/web-core-js/auth";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { ProductionOrderClient, type ProductionOrderDTO } from "../../../api/production";
import { ScrapTable } from "../ScrapTable";

/** The lot's engineering need against what it consumed; the scrap itself once it is completed. */
export function ScrapTab({ lot }: { lot: ProductionOrderDTO }) {
  const { t } = useTranslation();
  const { http } = useAuth();
  const scrap = useQuery({
    queryKey: ["production", "production-order", lot.id, "scrap"],
    queryFn: () => new ProductionOrderClient(http).scrap(lot.id),
  });
  return (
    <div className="flex min-h-0 flex-1 flex-col">
      <p className="border-b border-line px-4 py-2 text-[12px] text-ink-muted lg:px-6">
        {lot.status === "COMPLETED"
          ? t("scrap.hint.completed", "Scrap is what was consumed beyond the engineering need. Panels in m², every real panel's sheets together.")
          : t("scrap.hint.open", "Scrap is stated once the order is completed; until then consumption is still running. Panels in m².")}
      </p>
      <ScrapTable rows={scrap.data ?? []} loading={scrap.isLoading} />
    </div>
  );
}
